import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=3f658e2a&scoped=true&"
import script from "./ChatItem.vue?vue&type=script&lang=js&"
export * from "./ChatItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=3f658e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f658e2a",
  null
  
)

export default component.exports